import React from 'react';
import {SettingsSection, SettingsSectionTitleDict} from "../../../../../app/settings/@const";
import NavigationMenuSection from "../../../menu-items/section/section";
import NavigationSection from "../../../../../core/model2/navigation/navigation-section";
import NavigationMenuItemUrl from "../../../menu-items/menu-item-url";

type Props = {
    onToggle            : (a: string, b: boolean)=>void
    isManager?          : boolean
    collapseState       : any,
    navigationSection   : NavigationSection
}

export default function OrganizationSettings(props: Props) {


    const onToggle = (isOpen: boolean) => {
        props.onToggle('organization-settings', isOpen)
    };

    const counter = props.isManager?4:3;

    const isAdmin = gd.ac.check.isOrganizationAdmin(gd.companyId);


    // Company Users -> HR ?

    return (
        <NavigationMenuSection
            name="Organization settings"
            collapsible={true}
            onToggle={onToggle}
            counter={counter}
            // isOpen={!gd.user.menu.collapsedSettings.includes('organization-settings')}
            isOpen={!props.collapseState.isCollapsed('organization-settings')}
        >

            <NavigationMenuItemUrl name="All settings" icon="i5-nav-settings" url={`settings/${SettingsSection.COMPANY_ALL}`} navigationSection={props.navigationSection} />
            <NavigationMenuItemUrl name="Tasks & Projects" icon="i5-nav-projects" url={`settings/${SettingsSection.TASKS_PROJECTS}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="Productivity & Collaboration" icon="i5-nav-chat" url={`settings/${SettingsSection.PRODUCTIVITY}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="Automations" icon="i5-automation" url={`settings/${SettingsSection.AUTOMATIONS}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name={SettingsSectionTitleDict[SettingsSection.USERS]} icon="i5-users" url={`settings/${SettingsSection.USERS}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="Access & Permissions" icon="i5-key" url={`settings/${SettingsSection.ACCESS}`} navigationSection={props.navigationSection} />
            <NavigationMenuItemUrl name="Time and Resources" icon="i5-my-time" url={`settings/${SettingsSection.TIME_RESOURCES}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="Billing & Finance" icon="i5-expenses-light" url={`settings/${SettingsSection.BILLING}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="CRM" icon="i5-customer" url={`settings/${SettingsSection.CRM}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="Views" icon="icon i5-view" url={`settings/${SettingsSection.VIEWS}`} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="System" icon="i5-log" url={`settings/${SettingsSection.SYSTEM}`} navigationSection={props.navigationSection}/>
            {isAdmin && <NavigationMenuItemUrl name="Organization account" icon="i5-organization-profile" url={`settings/${SettingsSection.ACCOUNT}`} navigationSection={props.navigationSection}/>}

        </NavigationMenuSection>
    )

}
